export default __webpack_public_path__ + "static/media/takeshi1.99205631.jpg";